import { createFileRoute } from '@tanstack/react-router'

import { EmailMessagesPage } from '#/modules/communication/email-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/email-messages')({
  component: EmailMessagesPage,
  validateSearch: validateListSearch,
})
